// import components
import { Box } from '@mui/material';
import {
  StyledActionButton,
  StyledFontAwesomeSvgIcon
} from './ActionButtons.styles';

// import hooks
import { useTranslation } from 'react-i18next';
import useUpdateEmployeeMessageTask from '../hooks/useUpdateEmployeeMessageTask';
import { useQueryClient } from 'react-query';

// import types and props
import { ActionsButtonsProps, MessageActionType } from '../types';

const ActionsButtons = (props: ActionsButtonsProps) => {
  const { actions = [], taskId, sx, isRejectedDuty } = props;

  const availableActionTypes = actions.flatMap((action) =>
    Object.values(action)
  );

  const { t } = useTranslation('common', {
    keyPrefix: 'employeeMessages.actions'
  });
  const { mutateAsync: updateAction } = useUpdateEmployeeMessageTask();
  const queryClient = useQueryClient();

  const handleAction = async (
    event: React.MouseEvent,
    taskId: string | number,
    actionType: MessageActionType
  ) => {
    event.preventDefault();
    event.stopPropagation();

    await updateAction({ taskId, actionType });
    queryClient.invalidateQueries('employeeMessages');
  };

  return (
    <Box display="flex" gap={1} sx={sx || {}}>
      {availableActionTypes.map((type: MessageActionType, i: number) => (
        <StyledActionButton
          key={i}
          onClick={(event: React.MouseEvent) =>
            handleAction(event, taskId, type)
          }
          variant="outlined"
          color={`${
            isRejectedDuty ||
            type ===
              (MessageActionType.NOT_AVAILABLE || MessageActionType.REJECT)
              ? 'error'
              : 'primary'
          }`}
        >
          {(() => {
            switch (type) {
              case MessageActionType.ACCEPT:
              case MessageActionType.AVAILABLE:
                return <StyledFontAwesomeSvgIcon type="check" />;
              case MessageActionType.SEEN:
                return <StyledFontAwesomeSvgIcon type="check-double" />;
              case MessageActionType.NOT_AVAILABLE:
              case MessageActionType.REJECT:
                return <StyledFontAwesomeSvgIcon type="xmark" />;
              default:
                return null;
            }
          })()}
          {t(type)}
        </StyledActionButton>
      ))}
    </Box>
  );
};

export default ActionsButtons;
